import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { QuillModule } from "ngx-quill";

// store
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { effects, reducers } from "./store";

// services
import { SnackBarService } from "#services/snackbar.service";

// helpers
import { OpenSidePanelRightHelper } from "#helpers/open-side-panel-right.helper";

// directives
import { TrimInputDirective } from "#core/directives/trim-input/trim-input.directive";

// containers
import { NotificationComponent } from "./containers/notification/notification.component";
import { NotificationsComponent } from "./containers/notifications/notifications.component";
import { NewPmComponent } from "./containers/pm/new-pm.component";

// components
import { EditNotificationComponent } from "./components/edit/edit-notification.component";
import { NotificationsListComponent } from "./components/list/notifications-list.component";
import { ReplyPmComponent } from "./components/reply/reply-pm.component";
import { SendPmComponent } from "./components/send-pm/send-pm.component";
import { SendNotificationComponent } from "./components/send/send-notification.component";
import { NotificationsSentComponent } from "./components/sent-list/notifications-sent.component";

export const ROUTES: Routes = [
    { path: "send-notification", component: NotificationComponent },
    { path: "inbox", component: NotificationsComponent },
];

import { PrintErrorModule } from "#core/print-error/print-error.module";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatOptionModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { CoursesService, NotificationService } from "@carnegie-learning/data-access-angular-passport";
import {
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";
import { OwlMomentDateTimeModule } from "@danielmoncada/angular-datetime-picker-moment-adapter";

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(ROUTES),
        StoreModule.forFeature("notificationsModule", reducers),
        EffectsModule.forFeature(effects),
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatTabsModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        QuillModule,
        TrimInputDirective,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        OwlMomentDateTimeModule,
        PrintErrorModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatGridListModule,
        MatOptionModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatCardModule,
    ],
    declarations: [
        NotificationsListComponent,
        NotificationsSentComponent,
        NotificationsComponent,
        NotificationComponent,
        SendNotificationComponent,
        ReplyPmComponent,
        SendPmComponent,
        NewPmComponent,
        EditNotificationComponent,
    ],
    exports: [NotificationsComponent],
})
export class NotificationsModule {
    // to prevent duplicate instances of the sharedModule
    static forRoot(): ModuleWithProviders<NotificationsModule> {
        return {
            ngModule: NotificationsModule,
            providers: [
                NotificationService,
                CoursesService,
                OpenSidePanelRightHelper,
                SnackBarService,
            ],
        };
    }
}
